import { render, staticRenderFns } from "./GestionContactos.vue?vue&type=template&id=1b1eeee0&scoped=true"
import script from "./GestionContactos.vue?vue&type=script&lang=js"
export * from "./GestionContactos.vue?vue&type=script&lang=js"
import style0 from "./GestionContactos.vue?vue&type=style&index=0&id=1b1eeee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1eeee0",
  null
  
)

export default component.exports